import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';

export const useReportStatusData = () => {
	const [reportStatus, reportIsLoading] = useSelector<
		RootState,
		['success' | 'failure' | 'neutral', boolean]
	>(
		state => [
			state.report.get('getReportsStatus'),
			state.report.get('isLoading')
		],
		shallowEqual
	);

	return { reportStatus, reportIsLoading };
};
